/*
 * Copyright (c) Dito Technologies LLC
 */

import {graphql} from "babel-plugin-relay/macro";
import perform from "mutation/perform";
import {
    UpdatePieceFileChangeMIDINoteAndStartMutation$variables
} from "mutation/__generated__/UpdatePieceFileChangeMIDINoteAndStartMutation.graphql";

const mutation = graphql`
    mutation UpdatePieceFileChangeMIDINoteAndStartMutation($input: MusicUpdatePieceFileChangeMIDINoteAndStartInput!) {
        music_update_piece_file_change_midi_note_and_start(input: $input) {
            piece {
                id
                ...PiecePlayBody_piece
            }
        }
    }
`;

export default function UpdatePieceFileChangeMIDINoteAndStart(pieceId: string, bulbId: string, midiNumber: number, noteStart: number) {
    const variables: UpdatePieceFileChangeMIDINoteAndStartMutation$variables = {
        input: {
            piece_id: pieceId,
            bulb_id: bulbId,
            midi_number: midiNumber,
            note_start: noteStart
        }
    };
    return perform(mutation, variables);
}